import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import BarChart from 'components/charts/BarChart';
import Card from 'components/card/Card.js';
import { barChartOptionsDailyTraffic } from 'variables/charts';
import { getRecentMonths } from '../../../../functions/dateUtils';

export default function DailyLoginsRecentMonths(props) {
  const { history, categories, ...rest } = props;

  const [ lastMonth, setLastMonth] = useState(0)
  const [ monthlyLogins, setMonthlyLogins] = useState([{
    data: [0],
  }])

  useEffect(() => {
    try {
      if(history && history?.length > 0) {
        setLastMonth(history[history.length-1])
        setMonthlyLogins([{
          data: history
        }])
      }
    } catch (e) {

    }
  }, [history]);

  useEffect(()=>{
    barChartOptionsDailyTraffic.xaxis.categories =
      Array.isArray(categories) && categories.length > 0 ? categories : getRecentMonths();
  },[categories])

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Card align='center' direction='column' w='100%' p='16px' {...rest}>
      <Flex justify='space-between' align='start' px='8px' pt='0px' mb='8px'>
        <Flex flexDirection='column' align='start' me='16px'>
          <Flex w='100%'>
            <Text
              me='auto'
              color={textColor}
              fontSize={{ base: '16px', md: '18px' }}
              fontWeight='600'
              lineHeight='1.2'
              letterSpacing='0'>
              כניסות חודשיות ל-Payro
            </Text>
          </Flex>
          <Flex align='end' mt='4px'>
            <Text
              color={textColor}
              fontSize={{ base: '28px', md: '32px' }}
              fontWeight='700'
              lineHeight='1'
              letterSpacing='-0.02em'
              fontFeatureSettings='"tnum" on, "lnum" on'>
              {(lastMonth || 0).toLocaleString('en-US')}
            </Text>
            <Text
              ms='6px'
              color='secondaryGray.600'
              fontSize='12px'
              fontWeight='500'
              lineHeight='1.3'>
            בחודש האחרון
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Box h='220px' mt='auto'>
        <BarChart
            chartData={monthlyLogins}
            chartOptions={barChartOptionsDailyTraffic}
        />
      </Box>
    </Card>
  );
}
